import Resource from "./resource";
import {SensitiveValue} from "./propertyValueResource";
import {TenantedDeploymentMode} from "client/resources";

export interface CertificateResource extends Resource {
    Name: string;
    Notes?: string;
    CertificateData: SensitiveValue;
    Password: SensitiveValue;
    EnvironmentIds: string[];
    TenantIds: string[];
    TenantTags: string[];
    CertificateDataFormat?: CertificateDataFormat;
    Archived?: string;
    ReplacedBy?: string;
    SubjectDistinguishedName?: string;
    SubjectCommonName?: string;
    SubjectOrganization?: string;
    IssuerDistinguishedName?: string;
    IssuerCommonName?: string;
    IssuerOrganization?: string;
    SelfSigned?: boolean;
    Thumbprint?: string;
    NotAfter?: string;
    NotBefore?: string;
    IsExpired?: boolean;
    HasPrivateKey?: boolean;
    Version?: number;
    SerialNumber?: string;
    SignatureAlgorithmName?: string;
    TenantedDeploymentParticipation?: TenantedDeploymentMode;
    SubjectAlternativeNames?: string[];
    CertificateChain?: X509Certificate[];
}

export interface X509Certificate {
    SubjectDistinguishedName?: string;
    IssuerDistinguishedName?: string;
    Thumbprint?: string;
    NotAfter?: string;
    NotBefore?: string;
    Version?: number;
    SerialNumber?: string;
    SignatureAlgorithmName?: string;
}

export enum CertificateDataFormat {
    Pkcs12 = "Pkcs12",
    Der = "Der",
    Pem = "Pem"
}

export enum CertificateExportPemOptions {
    PrimaryOnly = "PrimaryOnly",
    PrimaryAndChain = "PrimaryAndChain",
    ChainOnly = "ChainOnly"
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/certificateResource.ts